export const globalFontSize = 16; //pixels

export const remCalc = (px, base = globalFontSize) => {
  let val = parseInt(px);
  let rem = parseFloat((val / parseInt(base, 10)).toPrecision(4));
  return rem + 'rem';
};

export const emCalc = (px, base = globalFontSize) => {
  let val = parseInt(px);
  let rem = parseFloat((val / parseInt(base, 10)).toPrecision(4));
  return rem + 'em';
};

export const pxCalc = (rem, base = globalFontSize) => {
  let val = parseFloat(rem);
  let px = (val * base).toFixed(1) + 'px';
  return px;
}

export const stripUnit = (value) => {
  return parseFloat(value);
};

export const getUnit = (value) => {
  return value.toString().replace(/[\d(,.)\s]/gm,'');
}

export const fluidProperty = ($property, $minValue, $maxValue, $minvw, $maxvw ) => {
  if (getUnit($minValue) && getUnit($minValue) === getUnit($maxValue) && getUnit($minValue.toLowerCase() !== 'px')) {
    $minValue = pxCalc($minValue);
    $maxValue = pxCalc($maxValue);
  }
  $minValue = stripUnit($minValue);
  $maxValue = stripUnit($maxValue);
  return `
    ${$property}: ${$minValue}px;
    
    @media screen and (min-width: ${emCalc($minvw)}) {
      ${$property}: calc(${$minValue}px + (${$maxValue} - ${$minValue}) * ((100vw - ${$minvw}px) / (${$maxvw} - ${$minvw})));
    }
    
    @media screen and (min-width: ${emCalc($maxvw)}) {
      ${$property}: ${$maxValue}px;
    }
  `
};

export const absoluteFull = () => {
  return `
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%; 
  `
};

export default remCalc;